<template>
  <GmapInfoWindow
    :options="options"
    :position="position"
    :opened="opened"
    @closeclick="$emit('closeclick')"
  >
    <div :class="$style.container" v-if="details">
      <img v-if="details.image" :src="details.image" :class="$style.image" />
      <div :class="$style.detail">
        <strong
          v-if="details.firstname"
          v-html="details.firstname + '&nbsp'"
          :class="$style.space"
        />
        <strong
          v-if="details.lastname"
          v-text="details.lastname"
          :class="$style.space"
        />
        <div
          v-if="details.position"
          v-text="details.position"
          :class="$style.space"
        />
        <strong
          v-if="details.company"
          v-text="details.company"
          :class="$style.space"
        />
        <div
          :class="$style.space"
          v-if="details.address"
          v-html="details.address.replace(/\n/g, '<br />')"
        />
        <a v-if="details.email" :href="`mailto:${details.email}`">
          {{ details.email }}
        </a>
        <a v-if="details.phone" :href="`tel:${details.phone}`">
          {{ details.phone }}
        </a>
        <a v-if="details.detailsLink" @click="displayDetails">
          {{ details.detailsLink }}
        </a>
        <a
          v-if="details.jobOffersLink && isJobOfferAvailable"
          :href="details.jobOffersUrl"
          target="_blank"
        >
          {{ details.jobOffersLink }}
        </a>
        <a
          v-if="useForm && details.formEmail"
          :href="prepareContactFormUrl(details)"
        >
          {{ dynamicFormLabel }}
        </a>
      </div>
    </div>
  </GmapInfoWindow>
</template>

<script>
import axios from "axios";
import { InfoWindow as GmapInfoWindow } from "gmap-vue";
import { prepareContactFormUrl } from "../../utils/form";

export default {
  name: "MapInfoWindow",
  components: {
    GmapInfoWindow
  },
  props: {
    position: {
      type: Object,
      default: () => undefined
    },
    opened: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    useForm: {
      type: Boolean,
      default: false
    },
	jobOfferJSONURL: {
      type: String,
      default: ""
    },
	filterKeyValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dynamicFormLabel: window.dictionary.dynamicForm,
	  jobOfferAvailable: false,
	  jobData: null,
      prepareContactFormUrl
    };
  },
  methods: {
    displayDetails() {
      this.$emit("displayDetails", this.details.detailsUrl);
    },
	jobOffersAvailable(url, filterKey, itemValue) {
	  if (itemValue)
	  {
		  axios
			.get(url)
			.then(response => {
				this.jobData = response.data.items.filter(item => item.filterCategories[filterKey] === itemValue);
				this.jobOfferAvailable = false;
				if(this.jobData != null && this.jobData.length > 0)
				{
					this.jobOfferAvailable = true;
				}
			})
			.catch(error => {
			  console.error(error);
			  return false;
			});
	  }
	  else
	  {
		this.jobOfferAvailable = true;
	  }
    }
  },
  computed: {
    isJobOfferAvailable(){
		this.jobOffersAvailable(this.jobOfferJSONURL, this.filterKeyValue, this.details.jobMappingValue);
		return(this.jobOfferAvailable);
	}	
  }
};
</script>

<style module lang="scss">
@import "./MapInfoWindow.scss";
</style>
